function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      // #1900
      this.size_options = this.querySelector('.product-card-sizes');
      // Product card slider
      this.slider = this.querySelector('.product-card-slider');
      this.sliderPagination = this.querySelector('.product-card-slider-pagination');
      this.sliderPaginationButtons = this.sliderPagination ? this.sliderPagination.querySelectorAll('button') : [];
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images.length > 0) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      // #1900
      if (this.size_options) {
        this.enableSizeOptions();
      }
      // Initialize slider if it exists
      if (this.slider) {
        this.enableSlider();
      }
    }
    // Add slider functionality
    enableSlider() {
      if (!this.slider || !this.sliderPagination) return;
      
      this.sliderSlides = this.slider.querySelectorAll('.product-card-slider-slide');
      if (this.sliderSlides.length <= 1) return;
      
      // Set initial state
      this.currentSlide = 0;
      
      // Add click handler to parent link to detect if pagination was clicked
      const parentLink = this.slider.closest('a');
      if (parentLink) {
        // Prevent link navigation when clicking on pagination
        this.sliderPagination.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        });
      }
      
      // Setup pagination buttons
      this.sliderPaginationButtons.forEach((button, index) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.goToSlide(index);
          return false;
        });
      });
      
      // Touch/swipe handling
      let startX, endX, startY, endY, startTime, isScrolling = false;
      
      const handleTouchStart = (e) => {
        // Don't interfere with normal scrolling
        if (e.touches.length > 1) return;
        
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startTime = new Date().getTime();
        isScrolling = false;
      };
      
      const handleTouchMove = (e) => {
        if (!startX || e.touches.length > 1) return;
        
        const diffX = Math.abs(e.touches[0].clientX - startX);
        const diffY = Math.abs(e.touches[0].clientY - startY);
        
        // Determine if the user is trying to scroll vertically
        if (diffY > diffX) {
          isScrolling = true;
        }
        
        endX = e.touches[0].clientX;
        endY = e.touches[0].clientY;
      };
      
      const handleTouchEnd = (e) => {
        if (!startX || !endX || isScrolling) {
          startX = null;
          endX = null;
          return;
        }
        
        const diff = startX - endX;
        const timeDiff = new Date().getTime() - startTime;
        
        // Check if it's a valid swipe: minimum distance and maximum time
        if (Math.abs(diff) > 50 && timeDiff < 300) {
          if (diff > 0) {
            // Swipe left - go to next slide
            this.goToSlide(this.currentSlide + 1);
            e.preventDefault();
          } else {
            // Swipe right - go to previous slide
            this.goToSlide(this.currentSlide - 1);
            e.preventDefault();
          }
        }
        
        startX = null;
        endX = null;
      };
      
      this.slider.addEventListener('touchstart', handleTouchStart, { passive: true });
      this.slider.addEventListener('touchmove', handleTouchMove, { passive: true });
      this.slider.addEventListener('touchend', handleTouchEnd);
      
      // Handle automatic slide detection when scrolling
      this.slider.addEventListener('scroll', () => {
        if (!this.isManualScrolling) {
          const slideWidth = this.sliderSlides[0].offsetWidth;
          const scrollPosition = this.slider.scrollLeft;
          const newSlideIndex = Math.round(scrollPosition / slideWidth);
          
          if (newSlideIndex !== this.currentSlide) {
            this.currentSlide = newSlideIndex;
            this.updatePagination();
          }
        }
      });
      
      // Make sure images are loaded correctly
      this.loadSliderImages();
    }
    
    loadSliderImages() {
      // Ensure all slider images are loaded
      const sliderImages = this.slider.querySelectorAll('img');
      sliderImages.forEach(img => {
        if (img.complete) {
          return;
        }
        img.addEventListener('load', () => {
          // Image loaded, ensure visibility
          img.style.opacity = 1;
        });
        
        if (img.dataset.src) {
          img.src = img.dataset.src;
        }
        
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
        }
        
        // If lazySizes is available, trigger load
        if (window.lazySizes) {
          lazySizes.loader.unveil(img);
        }
      });
    }
    
    goToSlide(index) {
      // Handle boundaries
      if (index < 0) {
        index = 0;
      } else if (index >= this.sliderSlides.length) {
        index = this.sliderSlides.length - 1;
      }
      
      // Update current slide
      this.currentSlide = index;
      
      // Scroll to the slide
      this.isManualScrolling = true;
      const slideWidth = this.sliderSlides[0].offsetWidth;
      this.slider.scrollTo({
        left: slideWidth * index,
        behavior: 'smooth'
      });
      
      // Update pagination
      this.updatePagination();
      
      // Ensure the image in current slide is loaded
      const currentSlideImg = this.sliderSlides[index].querySelector('img');
      if (currentSlideImg && window.lazySizes) {
        lazySizes.loader.unveil(currentSlideImg);
      }
      
      // Reset manual scrolling flag after animation completes
      setTimeout(() => {
        this.isManualScrolling = false;
      }, 500);
      
      // Prevent link navigation
      return false;
    }
    
    updatePagination() {
      this.sliderPaginationButtons.forEach((button, i) => {
        if (i === this.currentSlide) {
          button.classList.add('active');
        } else {
          button.classList.remove('active');
        }
      });
    }
    
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });

    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });

        swatch.addEventListener('mouseover', function () {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }
          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    // start of size option - #1900
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
             

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
                  const items = Array.isArray(response.items)
              ? response.items
              : [response];
              const primaryItem = items[0];
              
              let showCustomPopup = document.querySelector('#show-custom-popup')?.textContent

              /* Code by Ruby - Convx - TL-3172 */
              let showATCConfirmationBarPopUp = document.querySelector('#show-atc-confirmation-bar-popup').textContent
              if(showCustomPopup == 'true' && showATCConfirmationBarPopUp == 'false'){
                this.showConfirmationPopup(primaryItem, response);
              }
              if(showATCConfirmationBarPopUp == 'true' && showCustomPopup == 'false'){
                this.showATCConfirmationBarPopUp();
              }
              /* End of TL-3172 */
            
              this.renderContents(response);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    showConfirmationPopup(primaryItem, fullResponse) {
        console.log("=== SHOWING CONFIRMATION POPUP ===");
        let productTitle = primaryItem.product_title;
        let productImage = primaryItem.featured_image.url;
        let variantTitle = primaryItem.variant_title;
        let quantity = primaryItem.quantity || 1;
        // let variantPrice = document.querySelector(
        //   ".product-price-container .money"
        // )?.innerHTML;
  let variantElement = document.querySelector(
  `.variant-price[data-variant-id="${primaryItem.variant_id}"]`
);
  let variantPrice = variantElement?.querySelector(".money")?.textContent.trim() || "N/A";
  console.log("primaryItem",primaryItem)

        document.getElementById("popup-product-title").textContent =
          productTitle;
        document.getElementById("popup-product-image").src = productImage;
        document.getElementById("popup-product-price").textContent =
          variantPrice;
        document.getElementById("popup-product-size").textContent =
          variantTitle;
        document.getElementById("Quantity-confirmation-popup").value = quantity;

        this.setupPopupFunctionality(primaryItem, fullResponse);

        document.getElementById("slideup-popup").classList.add("active");
        document.getElementById("overlay").classList.add("show");
        document.body.style.overflow = "hidden";

        setTimeout(function () {
          $(".upsell-product-container").flickity({
            cellAlign: "left",
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            percentPosition: false,
            freeScroll: true,
          });
        }, 500);
        
        // Setup quantity controls for MAIN PRODUCT ONLY
        this.setupMainProductQuantityControls(primaryItem);
      }

      setupPopupFunctionality(primaryItem, fullResponse) {
        console.log(fullResponse,"fullResponsefullResponse")
        if(Array.isArray(fullResponse.items) && fullResponse.items.length == 0) window.location.reload();
        const getFreeShipping = (lineItemKey, totalQty) => {
          console.log("getFreeShipping called with:", lineItemKey, totalQty);

          fetch("/cart.js")
            .then((response) => response.json())
            .then((cart) => {
              $("#free-shipping-price").load(
                location.href + " #free-shipping-price"
              );

              let freeShippingThreshold = document
                .getElementById("free-shipping-price")
                .getAttribute("data-shipping-price");
              const currentTotal = cart.total_price / 100;
              const message = document.getElementById("free-shipping-message");
              const barFill = document.getElementById("free-shipping-bar-fill");

              if (currentTotal >= freeShippingThreshold) {
                message.innerHTML = "FREE shipping will be applied at checkout";
                barFill.style.width = "100%";
                barFill.style.backgroundColor = "#4caf50";
              } else {
                const remaining = (
                  freeShippingThreshold - currentTotal
                ).toFixed(2);
                      message.innerHTML = `You're <span id="free-shipping-price" class="money bacurr-money">${remaining}</span> away from Free Shipping!`;

const freeShippingEl = document.querySelector("#free-shipping-message #free-shipping-price");

// Only prepend "RM" if the element doesn't already contain any letters (i.e., currency)
if (freeShippingEl && !/[a-zA-Z]/.test(freeShippingEl.textContent)) {
  freeShippingEl.textContent = "RM" + freeShippingEl.textContent;
}

                const progress = (currentTotal / freeShippingThreshold) * 100;
                barFill.style.width = `${progress}%`;
                barFill.style.backgroundColor = "#BF9000";
              }
            })
            .catch((error) => {
              console.error("Error fetching cart:", error);
            });
        };

        getFreeShipping(primaryItem.key, primaryItem.quantity);
      }

      // === MAIN PRODUCT QUANTITY CONTROLS ===
      setupMainProductQuantityControls(primaryItem) {
  console.log("Setting up MAIN product quantity controls for:", primaryItem);

  const qtyInput = document.getElementById("Quantity-confirmation-popup");
  const plusBtn = document.querySelector(".popup-qty-container .plus");
  const minusBtn = document.querySelector(".popup-qty-container .minus");
  const deleteBtn = document.querySelector(".popup-qty-container .removeItem"); 

  if (!qtyInput || !plusBtn || !minusBtn) {
    console.warn("Main product quantity buttons or input not found.");
    return;
  }

  // Remove existing event listeners to prevent duplicates
  const newPlusBtn = plusBtn.cloneNode(true);
  const newMinusBtn = minusBtn.cloneNode(true);
  plusBtn.parentNode.replaceChild(newPlusBtn, plusBtn);
  minusBtn.parentNode.replaceChild(newMinusBtn, minusBtn);

  const updateMainProductQuantity = (newQty) => {
    console.log("Updating MAIN product cart quantity to:", newQty);

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: primaryItem.key,
        quantity: newQty,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw err;
          });
        }
        return response.json();
      })
      .then((cart) => {
        console.log("Main product cart updated:", cart);

        const updatedItem = cart.items.find(item => item.key === primaryItem.key);
        qtyInput.value = updatedItem ? updatedItem.quantity : newQty;

        const errorElement = document.querySelector(".popup-error-message");
        if (errorElement) errorElement.textContent = "";

        this.setupPopupFunctionality(primaryItem, cart);
      })
      .catch((err) => {
        console.error("Error updating main product cart:", err);
        const errorBox = document.querySelector(".popup-error-message");
        if (errorBox) {
          errorBox.textContent =
            err?.description ||
            "An error occurred while updating the cart.";
        }
      });
  };

  const deleteMainProduct = ((e) =>{
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: primaryItem.key,
        quantity: 0,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw err;
          });
        }
        return response.json();
      })
      .then((cart) => {
        console.log("Main product deleted from cart:", cart);

        // You might want to hide or reset the popup here
        e.target.closest(".popup-product-info").remove()
        
        this.setupPopupFunctionality(primaryItem, cart);
      })
      .catch((err) => {
        console.error("Error deleting main product from cart:", err);
        const errorBox = document.querySelector(".popup-error-message");
        if (errorBox) {
          errorBox.textContent =
            err?.description ||
            "An error occurred while deleting the product.";
        }
      });
  });

  // Plus button
  newPlusBtn.addEventListener("click", () => {
    console.log("Main product plus button clicked, current value:", qtyInput.value);
    let currentQty = parseInt(qtyInput.value, 10);
    if (isNaN(currentQty)) currentQty = 1;
    const newQty = currentQty + 1;
    updateMainProductQuantity(newQty);
  });

  // Minus button
  newMinusBtn.addEventListener("click", () => {
    console.log("Main product minus button clicked, current value:", qtyInput.value);
    let currentQty = parseInt(qtyInput.value, 10);
    if (isNaN(currentQty)) currentQty = 1;
    if (currentQty <= 1) return;
    const newQty = currentQty - 1;
    updateMainProductQuantity(newQty);
  });

  // Delete button
  if (deleteBtn) {
    deleteBtn.addEventListener("click", (e) => {
      console.log("Delete button clicked for main product.");
      deleteMainProduct(e);
    });
  }
}
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    // end of size option - #1900
    
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      // Code by Ruby - Convx - TL-3657 - (A = cart page, B = cart drawer)
      const abVariant = window.cartABTestVariant || 
                      (document.body ? document.body.getAttribute('data-cart-ab-variant') : null) || 
                      'A';
      // End of TL-3657
      
      if (document.getElementById('Cart-Drawer')) {
        // Code by Ruby - Convx - TL-3657
        if (abVariant === 'A') {
          window.location.href = theme.routes.cart_url;
          return;
        }
        // End of TL-3657
        
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    /* Code by Ruby - Convx - TL-3172 */
    showATCConfirmationBarPopUp() {
      const productAtcConfirmation = document.querySelector('#product-atc-confirmation-bar');
      if (productAtcConfirmation) {

        // Code by Ruby - Convx - TL-3824
        const freeShippingThresholdAttr = productAtcConfirmation.getAttribute('data-free-shipping-threshold');
        const progressMessageAttr = productAtcConfirmation.getAttribute('data-free-shipping-progress-message');
        const successMessageAttr = productAtcConfirmation.getAttribute('data-free-shipping-success-message');
        const parsedThreshold = parseFloat(freeShippingThresholdAttr);
        const isThresholdInvalid = !freeShippingThresholdAttr || 
                                  freeShippingThresholdAttr.trim() === '' || 
                                  isNaN(parsedThreshold) || 
                                  parsedThreshold <= 0;
        
        const isAnySettingBlank = isThresholdInvalid || 
                                  !progressMessageAttr || progressMessageAttr.trim() === '' || 
                                  !successMessageAttr || successMessageAttr.trim() === '';
        
        if (isAnySettingBlank) {
          const progressBarTextRows = document.querySelectorAll('.progress-bar-text-row');
          if(progressBarTextRows.length > 0){
            progressBarTextRows.forEach(row => {
              row.style.display = 'none';
            });
          }

          const content = document.querySelector('.product-atc-confirmation-content');
          if(content){
            content.style.alignItems = 'center';
          }
          
          const cartCol = document.querySelector('.product-atc-confirmation-cart-col');
          if (cartCol) {
            cartCol.style.paddingTop = '0';
          }
        }
        
        const freeShippingThreshold = parseFloat(freeShippingThresholdAttr);
        const progressMessage = progressMessageAttr;
        const successMessage = successMessageAttr;
        
        fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          const cartTotal = cart.total_price / 100;
          const freeShippingText = document.getElementById('product-atc-free-shipping-text');
          const progressBarFill = document.getElementById('product-atc-progress-bar-fill');
          
          if (freeShippingText) {
            if (cartTotal >= freeShippingThreshold) {
              freeShippingText.innerHTML = successMessage;
              if (progressBarFill) {
                progressBarFill.style.width = '100%';
              }
            } else {
              const remaining = (freeShippingThreshold - cartTotal).toFixed(2);
              const message = progressMessage.replace(/RMXX/g, `RM${remaining}`);
              freeShippingText.innerHTML = message;
              
              if (progressBarFill) {
                const progressPercentage = Math.min((cartTotal / freeShippingThreshold) * 100, 100);
                progressBarFill.style.width = `${progressPercentage}%`;
              }
            }
          }
        })
        .catch((error) => {
          console.error('Error fetching cart:', error);
          const freeShippingText = document.getElementById('product-atc-free-shipping-text');
          const progressBarFill = document.getElementById('product-atc-progress-bar-fill');
          if (freeShippingText) {
            freeShippingText.innerHTML = progressMessage.replace(/RMXX/g, 'RM0.00');
          }
          if (progressBarFill) {
            progressBarFill.style.width = '0%';
          }
        });
        // End of TL-3824

        productAtcConfirmation.classList.remove('hide');
        productAtcConfirmation.classList.add('show');
        
        this.setupCloseButtonListener();
        
        setTimeout(() => {
          productAtcConfirmation.classList.remove('show');
          productAtcConfirmation.classList.add('hide');
          
          setTimeout(() => {
            productAtcConfirmation.classList.remove('hide');
          }, 400);
        }, 5000);
      }
    }

    setupCloseButtonListener() {
      if (this.closeButtonListenerSetup) return;
      
      const productAtcConfirmationCloseBTN = document.querySelector('#product-atc-confirmation-bar .product-atc-confirmation-close-icon');
      
      if (productAtcConfirmationCloseBTN) {
        productAtcConfirmationCloseBTN.addEventListener('click', () => {
          const productAtcConfirmation = document.querySelector('#product-atc-confirmation-bar');
          
          if (productAtcConfirmation) {
            productAtcConfirmation.classList.remove('show');
            productAtcConfirmation.classList.add('hide');
            
            setTimeout(() => {
              productAtcConfirmation.classList.remove('hide');
            }, 400);
          }
        });
        
        this.closeButtonListenerSetup = true;
      }
    }
    /* End of TL-3172 */
  }
  customElements.define('product-card', ProductCard);
}
/**
 *  @class
 *  @function Header
 */
class Header {
  constructor() {
    const header = document.querySelector('.header-section'),
      header_main = document.getElementById('header'),
      menu = document.getElementById('mobile-menu'),
      toggle = document.querySelector('.mobile-toggle-wrapper'),
      setHeaderOffset = this.setHeaderOffset,
      setAnnouncementHeight = this.setAnnouncementHeight,
      setHeaderHeight = this.setHeaderHeight;

    if (!header_main) {
      return;
    }
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          toggle.removeAttribute('open');
          toggle.classList.remove('active');
        }
      }
    });
    toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
      setAnnouncementHeight(header);
      if (toggle.classList.contains('active')) {
        e.preventDefault();
        document.body.classList.remove('overflow-hidden');
        toggle.classList.remove('active');
        this.closeAnimation(toggle);

      } else {
        document.body.classList.add('overflow-hidden');
        setTimeout(() => {
          toggle.classList.add('active');
        });
      }
      window.dispatchEvent(new Event('resize.resize-select'));
    });

    // Mobile Menu offset
    window.addEventListener('scroll', function () {
      setHeaderOffset(header);
      setHeaderHeight(header_main);
      // Sticky Header Class
      if (header_main.classList.contains('header-sticky--active')) {
        let offset = parseInt(header_main.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;

        header_main.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }

    }, {
      passive: true
    });
    window.dispatchEvent(new Event('scroll'));

    if (document.getElementById('shopify-section-announcement-bar')) {
      const a_bar = document.getElementById('shopify-section-announcement-bar');
      window.addEventListener('resize', function () {
        setAnnouncementHeight(a_bar);
      }, {
        passive: true
      });
      window.dispatchEvent(new Event('resize'));
    }
    // Buttons.
    menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    menu.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }
  setAnnouncementHeight(a_bar) {
    let h = a_bar.clientHeight;
    document.documentElement.style.setProperty('--announcement-height', h + 'px');
  }
  setHeaderOffset(header) {
    let h = header.getBoundingClientRect().top;
    document.documentElement.style.setProperty('--header-offset', h + 'px');
  }
  setHeaderHeight(header) {
    let h = header.clientHeight;
    document.documentElement.style.setProperty('--header-height', h + 'px');
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.link-container');
    const isOpen = detailsElement.hasAttribute('open');

    setTimeout(() => {
      detailsElement.classList.add('menu-opening');
      parentMenuElement && parentMenuElement.classList.add('submenu-open');
      let megaMenuPromotion = document.querySelector('.mobile-menu-drawer--inner>.mega-menu-promotion');
      if(megaMenuPromotion){
        document.querySelector('.mobile-menu-drawer--inner>.mega-menu-promotion').style.display = "none";
      }
      document.querySelector('#mobile-menu').scrollTop = 0;
    }, 100);
  }
  onCloseButtonClick(event) {
    event.preventDefault();
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    let megaMenuPromotion = document.querySelector('.mobile-menu-drawer--inner>.mega-menu-promotion');
    if(megaMenuPromotion){
      document.querySelector('.mobile-menu-drawer--inner>.mega-menu-promotion').style.display = "block";
    }
    document.querySelector('#mobile-menu').scrollTop = 0;
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        detailsElement.querySelectorAll('details').forEach((details) => {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
          details.classList.remove('submenu-open');
          document.querySelector('.mobile-menu-drawer--inner>.mega-menu-promotion').style.display = "block";
          document.querySelector('#mobile-menu').scrollTop = 0;
        });
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener('resize', debounce(function () {
        _this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    constructor() {
      super();
      let cc = document.querySelector('.click-capture');

      // Add functionality to buttons
      this.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener('click', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
        // Code by Ruby - Convx - TL-3171
        e.stopPropagation();
        // End of TL-3171
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel');
      
        if (!panel) {
          return;
        }
      }

      // Code by Ruby - Convx - TL-3171
      // Always get fresh reference from DOM using panel ID to avoid stale references
      // This is important for Pickup-Availability because it uses innerHTML replacement
      if (panel && panel.id) {
        const freshPanel = document.getElementById(panel.id);
        if (freshPanel) {
          panel = freshPanel;
        }
      }
      // End of TL-3171

      if (panel.classList.contains('product-drawer')) {
        this.close_quick_view(panel);
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        // Code by Ruby - Convx - TL-3171 - comment the original code

        // panel.classList.remove('active');
        // document.body.classList.remove('open-cc');

        // Set a flag to prevent ClassWatcher callbacks from interfering during close
        if (panel && panel.id === 'Pickup-Availability') {
          panel.dataset.isClosing = 'true';
        }
        
        // Get fresh reference before removing classes
        let actualPanel = panel;
        if (panel && panel.id) {
          const freshPanel = document.getElementById(panel.id);
          if (freshPanel) {
            actualPanel = freshPanel;
            // Update the flag on fresh panel too
            if (actualPanel.id === 'Pickup-Availability') {
              actualPanel.dataset.isClosing = 'true';
            }
          }
        }
        
        if (actualPanel && actualPanel.classList && actualPanel.classList.contains('active')) {
          actualPanel.classList.remove('active');
        }
        
        if (document.body && document.body.classList && document.body.classList.contains('open-cc')) {
          document.body.classList.remove('open-cc');
        }
        
        if (document.body && document.body.classList && document.body.classList.contains('open-cart')) {
          document.body.classList.remove('open-cart');
        }
        
        // Clear the closing flag after a short delay to allow MutationObserver to settle
        if (actualPanel && actualPanel.id === 'Pickup-Availability') {
          setTimeout(() => {
            const finalPanel = document.getElementById('Pickup-Availability');
            if (finalPanel && finalPanel.dataset) {
              delete finalPanel.dataset.isClosing;
            }
          }, 150);
        }
        
        // console.log('panel remove active', actualPanel || panel);
        // console.log('document.body.classList', document.body.classList);

        // End of TL-3171
      }
    }
    close_quick_view(panel) {
      panel = panel ? panel : document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {

  constructor() {
    this.container = document.getElementById('Cart-Drawer');

    if (!this.container) {
      return;
    }
    let _this = this,
      button = document.getElementById('cart-drawer-toggle'),
      quantities = this.container.querySelectorAll('.quantity input');


    // Add functionality to buttons
    button.addEventListener('click', (e) => {
      // Code by Ruby - Convx - TL-3657 - (A = cart page, B = cart drawer)
      const abVariant = window.cartABTestVariant || 
                       (document.body ? document.body.getAttribute('data-cart-ab-variant') : null) || 
                       'A';
      
      if (abVariant === 'A') {
        // Don't prevent default - let the link navigate to cart page
        return;
      }
      
      // Variant B: Prevent default and open cart drawer
      // End of TL-3657

      e.preventDefault();
      document.body.classList.add('open-cc');
      document.body.classList.add('open-cart');
      this.container.classList.add('active');
      this.container.focus();
      setTimeout(() => {
        if (this.container.querySelector('.product-recommendations--full')) {
          this.container.querySelector('.product-recommendations--full').classList.add('active');
        }
      });
      dispatchCustomEvent('cart-drawer:open');
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.removeProductEvent();
    this.updateFreeShipping();
    // Terms checkbox
    this.termsCheckbox();
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartDrawerTerms'),
      checkout_button = this.container.querySelector('.button.checkout');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }
  updateFreeShipping() {
     const free_shippings = document.querySelectorAll('.free-shipping');

    console.log("Updating free shipping...");
    for(const free_shipping of free_shippings ){
        let amount_text = free_shipping.querySelector('.free-shipping--text span');
        let total = parseInt(free_shipping.dataset.cartTotal, 10);
        let minimum = Math.round(parseInt(free_shipping.dataset.minimum, 10) * (Shopify.currency.rate || 1));
        let minimumGift = free_shipping.dataset.minimumGift ? Math.round(parseInt(free_shipping.dataset.minimumGift, 10) * (Shopify.currency.rate || 1)) : null;
        let percentage = 1;
      
        if(minimumGift){
          if(total < minimumGift){
            percentage = total / minimumGift;
          }
        }
        else{
          if(total < minimum){
            percentage = total / minimum;
          }
        }
        
        if (total < minimum) {
          if (amount_text) {
            let remaining = minimum - total,
              format = window.theme.settings.money_with_currency_format || "${{amount}}";
            amount_text.innerHTML = formatMoney(remaining, format);
          }
        }
        else if (minimumGift && total < minimumGift) {
          if (amount_text) {
            let remaining = minimumGift - total,
              format = window.theme.settings.money_with_currency_format || "${{amount}}";
            amount_text.innerHTML = formatMoney(remaining, format);
          }
        }
        free_shipping.style.setProperty('--percentage', percentage);

        // Code by Ruby - Convx - TL-3657 - two-tier progress bar
        if (free_shipping.classList.contains('progress-bar-two-tier')) {
          let total = parseInt(free_shipping.dataset.cartTotal, 10);
          let tierOneMinimum = Math.round(parseInt(free_shipping.dataset.tierOneMinimum, 10) * (Shopify.currency.rate || 1));
          let tierTwoMinimum = free_shipping.dataset.tierTwoMinimum ? Math.round(parseInt(free_shipping.dataset.tierTwoMinimum, 10) * (Shopify.currency.rate || 1)) : null;
          let percentage = 1;
        
          if(tierTwoMinimum){
            if(total < tierTwoMinimum){
              percentage = total / tierTwoMinimum;
            }
          }
          else{
            if(total < tierOneMinimum){
              percentage = total / tierOneMinimum;
            }
          }
          free_shipping.style.setProperty('--percentage', percentage);
          
          const tierIconOne = free_shipping.querySelector('.tier-icon-one');
          const tierIconTwo = free_shipping.querySelector('.tier-icon-two');
          
          if (tierIconOne && tierTwoMinimum && tierTwoMinimum > 0) {
            const tierOnePosition = Math.min(100, Math.max(0, (tierOneMinimum / tierTwoMinimum) * 100));
            tierIconOne.style.left = `${tierOnePosition}%`;
            
            if (total >= tierOneMinimum) {
              tierIconOne.classList.add('tier-unlocked');
            } else {
              tierIconOne.classList.remove('tier-unlocked');
            }
          }
          
          if (tierIconTwo) {
            if (total >= tierTwoMinimum) {
              tierIconTwo.classList.add('tier-unlocked');
            } else {
              tierIconTwo.classList.remove('tier-unlocked');
            }
          }
          
          const existingMessages = free_shipping.querySelectorAll('.unlocked-message');
          let tierOneUnlockedText = free_shipping.getAttribute('data-tier-one-unlocked-message') || 
                                  "You've unlocked <strong>FREE Shipping!</strong>";
          let bothUnlockedText = free_shipping.getAttribute('data-both-unlocked-message') || 
                                "You've unlocked <strong>FREE Shipping</strong> and <strong>FREE Gift Box!</strong>";
          
          let shouldShowBoth = tierTwoMinimum && total >= tierTwoMinimum;
          let shouldShowTierOne = !shouldShowBoth && total >= tierOneMinimum;
          
          let hasCorrectMessage = false;
          if (shouldShowBoth) {
            hasCorrectMessage = Array.from(existingMessages).some(msg => 
              msg.textContent.includes('FREE Shipping') && msg.textContent.includes('FREE Gift Box')
            );
          } else if (shouldShowTierOne) {
            hasCorrectMessage = Array.from(existingMessages).some(msg => 
              msg.textContent.includes('FREE Shipping') && !msg.textContent.includes('FREE Gift Box')
            );
          } else {
            hasCorrectMessage = existingMessages.length === 0;
          }
          
          if (!hasCorrectMessage) {
            existingMessages.forEach(msg => msg.remove());
            
            if (shouldShowBoth) {
              const messageEl = document.createElement('p');
              messageEl.className = 'unlocked-message';
              messageEl.innerHTML = bothUnlockedText;
              free_shipping.appendChild(messageEl);
            } else if (shouldShowTierOne) {
              const messageEl = document.createElement('p');
              messageEl.className = 'unlocked-message';
              messageEl.innerHTML = tierOneUnlockedText;
              free_shipping.appendChild(messageEl);
            }
          }
          
          continue;
        }
        // End of TL-3657
    }
  }
  updateQuantity(line, quantity) {
    this.container.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    if (this.container.querySelector('.product-recommendations--full')) {
      this.container.querySelector('.product-recommendations--full').classList.remove('active');
    }
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        this.updateFreeShipping();
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });

        if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
      });
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.hide();
      }
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-localization-forms').forEach((localization) => {
      localization.addEventListener('change', (e) => {
        localization.querySelector('form').submit();
      });
    });
  }
}



/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
// if (!customElements.get('quick-view')) {
//   class QuickView extends HTMLElement {
//     constructor() {
//       super();
//     }
//     connectedCallback() {
//       this.cc = document.querySelector('.click-capture');
//       this.drawer = document.getElementById('Product-Drawer');
//       this.body = document.body;

//       this.addEventListener('click', this.setupEventListener.bind(this));

//     }
//     setupEventListener(e) {
//       e.preventDefault();
//       let productHandle = this.dataset.productHandle,
//         href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

//       // remove double `/` in case shop might have /en or language in URL
//       href = href.replace('//', '/');
//       if (!href || !productHandle) {
//         return;
//       }
//       if (this.classList.contains('loading')) {
//         return;
//       }
//       this.classList.add('loading');
//       fetch(href, {
//         method: 'GET'
//       })
//         .then((response) => {
//           this.classList.remove('loading');
//           return response.text();
//         })
//         .then(text => {
//           const sectionInnerHTML = new DOMParser()
//             .parseFromString(text, 'text/html')
//             .querySelector('#Product-Drawer-Content').innerHTML;

//           this.renderQuickview(sectionInnerHTML, href, productHandle);

//         });
//     }
//     renderQuickview(sectionInnerHTML, href, productHandle) {
//       if (sectionInnerHTML) {

//         this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

//         let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

//         if (js_files.length > 0) {
//           var head = document.getElementsByTagName('head')[0];
//           js_files.forEach((js_file, i) => {
//             let script = document.createElement('script');
//             script.src = js_file.src;
//             head.appendChild(script);
//           });
//         }

//         setTimeout(() => {
//           if (Shopify && Shopify.PaymentButton) {
//             Shopify.PaymentButton.init();
//           }
//           if (window.ProductModel) {
//             window.ProductModel.loadShopifyXR();
//           }
//         }, 300);

//         this.body.classList.add('open-cc');
//         this.body.classList.add('open-quick-view');
//         this.drawer.classList.add('active');

//         this.drawer.querySelector('.side-panel-close').focus();

//         setTimeout(() => {
//           this.drawer.querySelector('.product-quick-images--container').classList.add('active');
//         });
//         dispatchCustomEvent('quick-view:open', {
//           productUrl: href,
//           productHandle: productHandle
//         });
//         addIdToRecentlyViewed(productHandle);
//       }
//     }
//   }
//   customElements.define('quick-view', QuickView);
// }
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
      // let productTitle = this?.dataset?.title
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      const variantTitle = this?.dataset?.title;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle,variantTitle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle,variantTitle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');
        // console.log("this.drawer", this.drawer,variantTitle)
        // console.log("this.drawer", this.drawer, variantTitle);

        const radios = this.drawer.querySelectorAll('input[type="radio"].option-disabler');

        const variantParts = variantTitle.split('/').map(part => part.trim());

        radios.forEach(radio => {
          const radioValue = radio.value.trim();
          
          if (variantParts.includes(radioValue)) {
            // console.log("Matched radio:", radio);
            radio.click();
          }

          
        });


        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container').classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        setTimeout(() => {
          this.prepareAnimations();
          this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
        }, 400);
      }
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector('summary').offsetHeight,
        content_height = this.querySelector('.collapsible__content').offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height;

      this.tl = false;
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: 'sine.inOut',
        onStart: function () {
          _this.details.open = true;
          _this.details.style.overflow = 'hidden';
        },
        onReverseComplete: function () {
          _this.details.open = false;
          _this.details.style.overflow = '';
        }
      });

      this.tl
        .fromTo(_this.details, {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24);
            return h;
          },
          clearProps: 'height'
        }, {
          duration: 0.6,
          height: final_height,
          clearProps: 'height'
        });

      if (this.details.open) {
        this.tl.progress(1);
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      e.preventDefault();
      if (this.tl.reversed()) {
        this.tl.timeScale(1).play();
      } else {
        this.tl.timeScale(3).reverse();
      }
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}
/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;

      if (!handle) {
        return;
      }
    }
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof (recentIds) !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {

  if (typeof Localization !== 'undefined') {
    new Localization();
  }
  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer();
  }
  if (typeof Header !== 'undefined') {
    new Header();
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }

  bindCalculator();
});

function bindCalculator(){
  let weightInput = document.getElementById('txtWeight');
  let heightInput = document.getElementById('txtHeight');

  if(weightInput) weightInput.addEventListener('keyup', calculateSize);
  if(heightInput) heightInput.addEventListener('keyup', calculateSize);
}

function getSize(weight, height){
  let calcweights = document.querySelector("#size_calculator").getAttribute("calcweights");
  let sizeup = document.querySelector("#size_calculator").getAttribute("sizeup");

  calcweights = calcweights.split(",");
  let index = -2;
  calcweights.forEach((weightAndSize, forIndex)=>{
    let weightRange = weightAndSize.split(":")[0];

    let weight1 = weightRange.split("-")[0];
    let weight2 = weightRange.split("-")[1];

    if(weight >= weight1 && weight <= weight2){
      index = forIndex;
    }
  })
  if(height > sizeup){
    index = index + 1;
  }
  return calcweights[index] ? calcweights[index].split(":")[1] : "NA";
}

function calculateSize() {
  let valWeight = document.querySelector("#txtWeight").value;
  let valHeight = document.querySelector("#txtHeight").value;

  let txtWeight = parseInt(valWeight);
  let txtHeight = parseInt(valHeight);

  if(isNaN(txtWeight) || isNaN(txtHeight)){
    document.querySelector("#dvOutputQuestion").innerHTML = ("?");

  }
  else{
    let txtSize = getSize(txtWeight, txtHeight);
    document.querySelector("#dvOutputQuestion").innerHTML = (txtSize);
  }

}